// NPM
import _ from 'lodash';

// Services
import embedService from 'services/embedService';

function canRender(dependencies) {
  const validatedDependencies = dependencies.map(d => !_.isBlank(d));
  if(_.every(validatedDependencies)) {
    embedService.postHeight();
    return true;
  }
  else {
    return false;
  }
}

export default {
  canRender
}